export default __webpack_public_path__ + "static/media/login.5001ff47.png";